export default function BackToTop({ action }) {
  return (
      <button onClick={action} className='fixed right-6 fill bottom-28 transaction ease-in-out delay-150 shadow-md hover:bg-blue-200 p-2 rounded-lg bg-white text-blue-900'>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 stroke-2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75" />
        </svg>
    </button>
  )
}
